import React from 'react';
import ProposalShape from './ProposalShape';

const proposalShapeConfig = {
  label: 'Forme',
  defaultProps: {
    shape: 'rectangle',
    color: 'rgba(0,0,0,1)',
    width: 120,
    height: 40,
    alignment: 'left',
    rotation: 0,
    borderColor: null,
    borderWidth: 0,
  },
  fields: {},
  render: ({ id, shape, color, width, height, alignment, rotation, borderColor, borderWidth }) => (
    <ProposalShape
      id={id}
      shape={shape}
      color={color}
      width={width}
      height={height}
      alignment={alignment}
      rotation={rotation}
      borderColor={borderColor}
      borderWidth={borderWidth}
    />
  ),
};

export default proposalShapeConfig;
